import React from 'react';
import { useTranslation } from "react-i18next";
import { MyPanel, MyHead1 } from '../../component/ui/UI';

export const PrivacyPolicyPage = () =>
{
	const { t } = useTranslation();

	return (
		<div className="d-flex flex-column p-1 gap-1">
			<MyPanel>
				<MyHead1>
					プライバシーポリシー
				</MyHead1>
				<p>
					準備中です。
				</p>
			</MyPanel>
		</div>
	);
};
